import { API_ENDPOINTS } from '@/api/endpoints';
import { PaginatedResponse } from '@/types/pagination';
import { Member, User } from '@/types/user';
import { apiFetch } from '@/util/apiClient';

export async function fetchOrganizationUsers(params: {
  organizationId: string;
  page: number;
  search?: string;
  showArchived?: boolean;
  department?: string;
}): Promise<PaginatedResponse<Member>> {
  const searchParams = new URLSearchParams({
    page: params.page.toString(),
    ...(params.search && { search: params.search }),
    ...(params.showArchived && { showArchived: 'true' }),
    ...(params.department && { department: params.department }),
  });
  return apiFetch<PaginatedResponse<Member>>(
    `${API_ENDPOINTS.ORGANIZATIONS.USERS(params.organizationId)}?${searchParams}`,
  );
}

export async function getCurrentOrganizationUser(
  organizationId: string,
): Promise<Member> {
  return apiFetch<Member>(
    `${API_ENDPOINTS.ORGANIZATIONS.CURRUSER(organizationId)}`,
  );
}

export async function updateOrganizationUser(
  organizationId: string,
  userId: string,
  data: Partial<Member> &
    Partial<User> & {
      department_ids?: string[];
      departmentIds?: string[];
      isArchived?: boolean;
      role?: string;
    },
): Promise<Member> {
  return apiFetch<Member>(
    `${API_ENDPOINTS.ORGANIZATIONS.USERS(organizationId)}${userId}/`,
    {
      method: 'PATCH',
      body: JSON.stringify(data),
    },
  );
}

export async function archiveOrganizationUser(
  organizationId: string,
  userId: string,
): Promise<void> {
  await apiFetch(
    `${API_ENDPOINTS.ORGANIZATIONS.USERS(organizationId)}${userId}/`,
    { method: 'DELETE' },
  );
}

export async function restoreOrganizationUser(
  organizationId: string,
  userId: string,
): Promise<Member> {
  return updateOrganizationUser(organizationId, userId, { isArchived: false });
}
